import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var TreeNodeContainer = function TreeNodeContainer(_ref) {
  var isOpen = _ref.isOpen,
    groupId = _ref.groupId,
    children = _ref.children;
  var treeNodeContainerClasses = classNames('TreeNodeContainer', 'user-select-none', isOpen && 'open');
  return /*#__PURE__*/React.createElement("div", {
    className: treeNodeContainerClasses,
    "data-id": groupId
  }, children);
};
TreeNodeContainer.displayName = 'TreeNodeContainer';
TreeNodeContainer.propTypes = {
  maxHeight: PropTypes.number
};
export default TreeNodeContainer;